// extracted by mini-css-extract-plugin
module.exports = {"service-text":"CustomServicesModal_service-text__2I5uX","services-container":"CustomServicesModal_services-container__oRNud"};